function timePeriodFilter($translate) {
    'ngInject';

    return function (v) {

        if (!angular.isNumber(v)) {
            return;
        }

        let minutes = parseInt(v);

        const hours = Math.floor(minutes / 60);
        minutes %= 60;
        const show_seperator = (hours > 0) && (minutes > 0);

        const time_period = $translate.instant('CORE.FILTERS.TIME_PERIOD.TIME_PERIOD', {
            hours,
            minutes,
            show_seperator: +show_seperator
        }, 'messageformat');

        return time_period;
    };
}

/**
 * @ngdoc filter
 * @name time_period
 * @kind function
 *
 * @description
 * Formats a number as a humanized duration, e.g. 1 hour, 2 minutes
 *
 * @param {number} minutes Input to format
 * @returns {string} Humanized duration.
 *
 *

 <example module="timePeriodExample">
 <file name="index.html">
 <script>
 angular.module('timePeriodExample', [])
 .controller('ExampleController', ['$scope', function($scope) {
 $scope.duration = 90;
 }]);
 </script>
 <div ng-controller="ExampleController">
 <span>Duration: {{amount | time_period}}</span>
 </div>
 </file>
 </example>
 */
angular
    .module('BB')
    .filter('time_period', timePeriodFilter);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/time_period.filter.js